const ptBR = {
  header: {
    home: 'Onnix Dev — início', openMenu: 'Abrir menu', closeMenu: 'Fechar menu',
    navigation: 'Navegação principal', language: 'Idioma',
    solutions: 'Soluções', projects: 'Projetos', about: 'Sobre a Onnix', contact: 'Vamos conversar',
  },
  hero: {
    eyebrow: 'Onnix Dev · Estúdio independente de software',
    titleStart: 'Sites, sistemas e automações', titleBridge: 'que fazem', titleAccent: 'seu negócio avançar.',
    description: 'Desenvolvemos soluções digitais para pequenas empresas, clínicas e prestadores de serviços que querem conquistar clientes, organizar processos e reduzir trabalho manual.',
    primaryCta: 'Conversar sobre meu projeto', secondaryCta: 'Conhecer projetos',
    capabilitiesLabel: 'O que desenvolvemos',
    capabilities: [
      { label: '01 / Presença digital', title: 'Sites e landing pages', description: 'Sua empresa bem apresentada para conquistar novos clientes.' },
      { label: '02 / Sua operação', title: 'Sistemas e agendamentos', description: 'Processos organizados, sem se limitar a ferramentas genéricas.' },
      { label: '03 / Tudo conectado', title: 'Automações e integrações', description: 'Menos tarefas manuais, com WhatsApp, agendas e sistemas conectados.' },
    ],
  },
  value: {
    eyebrow: 'Do cliente à operação', title: 'Mais clareza para quem chega. Menos esforço para quem atende.',
    description: 'Quando o digital não acompanha a rotina, o cliente encontra barreiras e a equipe precisa compensar com trabalho manual.',
    link: 'Veja como podemos ajudar', listLabel: 'Onde a tecnologia pode ajudar',
    outcomes: [
      { title: 'Facilitar o primeiro contato', problem: 'Serviços e canais de contato difíceis de encontrar tornam o primeiro passo menos claro.', result: 'Informações e contato acessíveis no mesmo lugar.' },
      { title: 'Organizar a rotina de atendimento', problem: 'Horários, pedidos e dados em registros separados exigem conferências e tarefas repetidas.', result: 'Mais organização para conduzir o dia a dia.' },
      { title: 'Dar continuidade ao trabalho', problem: 'Repassar informações entre ferramentas e controles individuais pode gerar retrabalho.', result: 'Processos conectados, com menos repasses manuais.' },
    ],
  },
  services: {
    eyebrow: 'O que desenvolvemos', title: 'Soluções para sua presença digital e sua operação.',
    intro: 'De um site profissional a um fluxo de trabalho mais organizado, o projeto começa pelas necessidades da sua empresa.',
    solutionLabel: 'Como podemos ajudar', contactTitle: 'Não sabe por onde começar?',
    contactDescription: 'Conte como sua empresa funciona. Vamos entender a necessidade antes de definir o escopo.',
    contactCta: 'Conversar sobre uma solução',
    items: [
      {
        id: 'sites', title: 'Sites e Landing Pages',
        problem: 'Sua empresa precisa transmitir confiança e facilitar o contato com novos clientes.',
        solution: 'Criamos sites institucionais, páginas de vendas e landing pages responsivas, conforme as necessidades do seu negócio.',
        listLabel: 'Para facilitar',
        highlights: ['Presença digital profissional', 'Apresentação clara dos serviços', 'Contato facilitado', 'Captação de oportunidades'],
        scope: 'Formulários, acompanhamento de acessos e conexões com ferramentas de captação podem ser avaliados no escopo.',
        contactLabel: 'Conversar sobre sites',
        message: 'Olá, Onnix Dev! Gostaria de conversar sobre um projeto de site ou landing page para minha empresa.',
      },
      {
        id: 'sistemas', title: 'Sistemas Personalizados',
        problem: 'Planilhas e ferramentas desconectadas podem dificultar a organização da sua operação.',
        solution: 'Desenvolvemos sistemas web para organizar processos, informações e rotinas específicas da sua empresa.',
        listLabel: 'Para facilitar',
        highlights: ['Processos mais organizados', 'Informações centralizadas', 'Menos trabalho manual', 'Soluções adaptadas ao negócio'],
        scope: 'Painéis de gestão, controles de estoque e portais com acesso restrito são exemplos de escopo a definir.',
        contactLabel: 'Conversar sobre sistemas',
        message: 'Olá, Onnix Dev! Gostaria de conversar sobre um sistema personalizado para organizar os processos da minha empresa.',
      },
      {
        id: 'agendamentos', title: 'Agendamentos Inteligentes',
        problem: 'Organizar horários e solicitações manualmente pode consumir tempo da equipe.',
        solution: 'Criamos soluções de agendamento com recursos definidos conforme sua rotina e suas necessidades de atendimento.',
        listLabel: 'Possibilidades do projeto',
        highlights: ['Gestão de horários', 'Solicitações de agendamento', 'Confirmações', 'Organização de atendimentos'],
        scope: 'Os recursos e eventuais integrações dependem de validação técnica e do escopo contratado.',
        contactLabel: 'Conversar sobre agendamentos',
        message: 'Olá, Onnix Dev! Gostaria de conversar sobre um sistema de agendamento para o meu negócio.',
      },
      {
        id: 'automacoes', title: 'Automações e Integrações',
        problem: 'Tarefas repetitivas e informações espalhadas entre ferramentas podem gerar retrabalho.',
        solution: 'Desenhamos automações e integrações para conectar processos e reduzir operações manuais, conforme a viabilidade das ferramentas utilizadas.',
        listLabel: 'Possibilidades do projeto',
        highlights: ['Automatização de tarefas', 'Integração entre ferramentas', 'Organização de informações', 'Fluxos personalizados'],
        scope: 'Conexões com WhatsApp, CRM, ERP ou planilhas são avaliadas caso a caso.',
        contactLabel: 'Conversar sobre automações',
        message: 'Olá, Onnix Dev! Gostaria de avaliar automações e integrações para reduzir tarefas manuais na minha empresa.',
      },
    ],
  },
  portfolio: {
    eyebrow: 'Projetos selecionados', title: 'Soluções que mostram como trabalhamos.',
    intro: 'De uma presença digital bem apresentada a ferramentas para a operação, cada projeto parte de uma necessidade concreta.',
    kinds: { commercial: 'Projeto comercial', own: 'Projeto próprio', demo: 'Projeto demonstrativo' },
    imagePlaceholder: 'Imagem do projeto em preparação', challenge: 'Desafio', importance: 'Por que importa',
    capabilitiesLabel: 'Recursos do projeto', demoLink: 'Ver demonstração', demoAria: 'Ver demonstração de', repositoryLink: 'Explorar repositório', repositoryAria: 'Explorar repositório de', newTab: 'nova aba',
    contactEyebrow: 'Vamos conversar', contactTitle: 'Seu negócio pode ser o próximo projeto.',
    contactDescription: 'De um site profissional a um sistema sob medida, vamos entender o que sua operação precisa.',
    contactCta: 'Conversar sobre meu projeto',
  },
  comparison: {
    eyebrow: 'Escolha certa', title: 'Planilhas, softwares genéricos ou Onnix Dev?',
    cards: [
      { title: 'Planilhas', points: ['Depende de pessoas certas', 'Sem logs ou alertas', 'Difícil de integrar', 'Erro humano constante'] },
      { title: 'Software genérico', points: ['Você se adapta ao sistema', 'Falta de suporte consultivo', 'Customizações caras e lentas', 'Funcionalidades que ninguém usa'] },
      { title: 'Onnix Dev', points: ['Arquitetura sob medida', 'Automação entre todos os canais', 'Time direto com quem desenvolve', 'Sprints com entregas semanais'] },
    ],
    contactTitle: 'Vamos conversar sobre formas de organizar sua operação.', contactCta: 'Conversar sobre possibilidades',
  },
  fit: {
    eyebrow: 'Alinhamento sincero', title: 'Não é para todo mundo. Veja se faz sentido para você.',
    notFor: { title: 'Não é para quem', points: ['Busca soluções prontas e baratas', 'Não tem processos definidos', 'Prefere manter controles 100% manuais'] },
    for: { title: 'É para quem', points: ['Quer tirar o time do operacional', 'Precisa de integrações robustas', 'Valoriza velocidade e suporte direto', 'Mede ROI de tecnologia', 'Tem urgência para liberar capacidade'] },
  },
  process: {
    eyebrow: 'Processo', title: 'Fluxo leve, claro e pensado para entregar valor rápido.',
    steps: [
      { title: 'Imersão focada', description: 'Entendemos os fluxos atuais, identificamos gargalos e definimos os indicadores que serão impactados.' },
      { title: 'Blueprint aprovado', description: 'Protótipo navegável + arquitetura do sistema validados com você antes de qualquer desenvolvimento.' },
      { title: 'Dev iterativo', description: 'Sprints semanais, entregas visíveis e comunicação direta. Zero surpresas. Cada ciclo libera valor real.' },
      { title: 'Go-live assistido', description: 'Monitoramento ativo, ajustes finos e suporte próximo nos primeiros dias de operação.' },
      { title: 'Otimização contínua', description: 'Melhorias constantes conforme o sistema ganha dados e a operação evolui.' },
    ],
  },
  about: {
    eyebrow: 'Quem faz', title: 'Onnix Dev é um estúdio independente de tecnologia.',
    description: 'Operado por Gabriel Fernandes, desenvolvedor especializado em automação e sistemas web. Um estúdio enxuto para garantir proximidade, velocidade e soluções criadas exatamente para a realidade de cada empresa.',
    why: 'Por que escolher a Onnix?',
    points: ['Foco total em ROI: cada sprint precisa liberar horas ou gerar receita.', 'Design limpo, rápido e inspirado na experiência da Linear.', 'Suporte direto com quem construiu o sistema.'],
  },
  contact: {
    eyebrow: 'Vamos conversar', title: 'Seu próximo projeto começa com uma conversa.',
    description: 'Conte o que seu negócio precisa. Vamos entender seu desafio e encontrar uma solução digital que faça sentido para você.',
    primaryCta: 'Conversar sobre meu projeto', emailCta: 'Enviar um e-mail', nextStep: 'Como começamos',
    steps: ['Você conta o que precisa, sem ter que definir a solução técnica.', 'Conversamos sobre possibilidades e próximos passos.'],
  },
  footer: {
    description: 'Tecnologia para simplificar processos e ajudar negócios a avançar.',
    navigation: 'Navegação', navigationLabel: 'Navegação do rodapé', home: 'Início', services: 'Serviços', projects: 'Projetos', contact: 'Contato',
    solutions: 'Soluções', explore: 'Explorar soluções', contactTitle: 'Fale com a Onnix',
    serviceNames: ['Sites e Landing Pages', 'Sistemas Personalizados', 'Agendamentos Inteligentes', 'Automações e Integrações'],
    independent: 'Estúdio independente de software.',
  },
  contactMessages: {
    general: 'Olá! Conheci a Onnix Dev pelo site e gostaria de conversar sobre um projeto.',
    services: 'Olá! Tenho interesse nas soluções da Onnix Dev e gostaria de entender como vocês podem ajudar meu negócio.',
    portfolio: 'Olá! Vi os projetos da Onnix Dev e gostaria de conversar sobre uma solução semelhante para minha empresa.',
    consultation: 'Olá! Gostaria de conversar sobre possibilidades para organizar os processos da minha empresa.',
  },
};

export default ptBR;
